import { TreeNode, TreeNodeType } from ".";
import { StepItem } from "~/components/build/Show/components/Sidebar/TreeNode/StepItem";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import { CommandStep, isFailed } from "~/lib/pipeline";
import useQueryParams from "~/components/build/Show/lib/useQueryParams";

interface Props {
  step: CommandStep;
  depth?: number;
}

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeNode/CommandStepItem` instead. */
export function CommandStepItem(props: Props) {
  const { currentStep } = useCurrentJobOrStep();
  const params = useQueryParams();

  return (
    <StepItem
      {...props}
      active={
        props.step.uuid === currentStep?.uuid ||
        (Boolean(params.jid) && props.step.statistics?.latestJobId === params.jid)
      }
      failed={isFailed(props.step)}
    />
  );
}

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeNode/CommandStepItem` instead. */
export const createCommandStepNode = (step: CommandStep): TreeNode => ({
  id: step.uuid,
  type: TreeNodeType.StepCommand,
  render: (props) => <CommandStepItem step={step} {...props} />,
});
